import React from 'react';
import styled from 'styled-components';
import Flex from '../Flex/Flex';
import theme from '../../assets/styles/theme';

const weekDays = ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES'];

const DaysHeader = () => {
  const days = weekDays.map((day) => {
    return (
      <DaysContainer key={day}>
        <DayText>{day}</DayText>
      </DaysContainer>
    );
  });

  return <Header key={'pepe'}>{days}</Header>;
};

const Header = styled(Flex)`
  height: 50px;
  background-color: ${theme.oldColors.grey[400]};
  align-items: center;
`;

const DaysContainer = styled.div`
  flex: 1;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DayText = styled.div`
  font-size: 12px;
`;

export default DaysHeader;
